<template>
  <q-list>
    <q-item-label header>
      <q-item-section class="mobile-only">
        <q-toolbar>
          <q-toolbar-title >
            <q-avatar>
              <img
                alt="abraao.dev logo"
                src="@/assets/logo.png"
              >
            </q-avatar>
            <span class="text-bold q-pl-sm">abraao.dev</span>
          </q-toolbar-title>
          <q-btn
            dense
            flat
            round
            icon="close"
            aria-label="Close the menu"
            @click="$emit('closerMenu')"
          />
        </q-toolbar>
      </q-item-section>
    </q-item-label>
    <q-item
      clickable
      to="/"
    >
      <q-item-section avatar>
        <q-icon name="home" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Home</q-item-label>
        <q-item-label caption>abraao.dev</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      to="/about"
    >
      <q-item-section avatar>
        <q-icon name="info" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Sobre</q-item-label>
        <q-item-label caption>Sobre mim</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      to="/contact"
    >
      <q-item-section avatar>
        <q-icon name="email" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Contato</q-item-label>
        <q-item-label caption>Envie uma mensagem</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      tag="a"
      target="_blank"
      href="https://github.com/abraaopinto"
    >
      <q-item-section avatar>
        <q-icon name="fab fa-github" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Github</q-item-label>
        <q-item-label caption>github.com/abraaopinto</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      tag="a"
      target="_blank"
      href="https://twitter.com/abraao_dev"
    >
      <q-item-section avatar>
        <q-icon name="fab fa-twitter" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Twitter</q-item-label>
        <q-item-label caption>@abraao_dev</q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      tag="a"
      target="_blank"
      href="https://br.linkedin.com/in/abra%C3%A3o-pinto-8a1a06170"
    >
      <q-item-section avatar>
        <q-icon name="fab fa-linkedin" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Linkedin</q-item-label>
        <q-item-label caption>Abraão Pinto</q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {

}
</script>

<style>
</style>
